module.exports = {
      id: "icon-star-usage",
      viewBox: "0 0 30.754 29.435",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }